import {
    Box,
    Button,
  Dialog,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React from 'react';
import ImageIcon from "@mui/icons-material/Image";
import { resolveSrc } from 'src/api/endpoints';
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import SlowMotionVideoIcon from "@mui/icons-material/SlowMotionVideo";
import { Stack } from '@mui/system';

const PlaylistContentList = ({ playlistContent, open, onClose }) => {
  return (
    <Dialog
      sx={{
        p: 3,
        zIndex: 1000001
      }}
      maxWidth="md"
      fullWidth
      open={open}
      onClose={onClose}
    >
        <DialogContent sx={{
            p: 3
        }}>
            <Table>
                <TableBody>
                        {playlistContent?.content && playlistContent.content.map((pi, index) => {
                        const pc = pi.content
                        return (
                            <TableRow key={pi._id}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>
                                {pc.type === 'image' && (
                                <img
                                    src={resolveSrc(pc?.url)}
                                    style={{
                                    maxWidth: '110px',
                                    height: 'auto',
                                    maxHeight: '60px',
                                    display: 'block',
                                    margin: 'auto',
                                    }}
                                />
                                )}
                                {(pc.type === 'widget' || pc.type === 'split_screen') && (
                                <img
                                    src={`${pc.widget?.widgetIcon}`}
                                    style={{
                                    maxWidth: '110px',
                                    height: 'auto',
                                    maxHeight: '60px',
                                    display: 'block',
                                    margin: 'auto',
                                    }}
                                />
                                )}
            
                                {pc.type === 'video' && (
                                <video
                                    src={resolveSrc(pc?.url)}
                                    controls={false}
                                    autoPlay={false}
                                    muted
                                    style={{
                                    width: '110px',
                                    height: 'auto',
                                    maxHeight: '60px',
                                    margin: 'auto',
                                    }}
                                />
                                )}
                                {pc.embed === 'embed' && (
                                <embed
                                    src={`${pc.url}`}
                                    style={{
                                    maxWidth: '110px',
                                    height: 'auto',
                                    maxHeight: '60px',
                                    margin: 'auto',
                                    }}
                                />
                                )}
                            </TableCell>
                            <TableCell align='left'>
                                {pc.type === 'image' && <ImageIcon htmlColor='#6c737f' />}
                                {pc.type === 'widget' && (
                                <AppRegistrationIcon htmlColor='#6c737f' />
                                )}
                                {pc.type === 'video' && (
                                <SlowMotionVideoIcon htmlColor='#6c737f' />
                                )}
                                {pc.embed === 'embed' && (
                                <AppRegistrationIcon htmlColor='#6c737f' />
                                )}
                                {!(
                                pc.type === 'image' ||
                                pc.type === 'widget' ||
                                pc.type === 'video' ||
                                pc.embed === 'embed'
                                ) && <AppRegistrationIcon htmlColor='#6c737f' />}
                            </TableCell>
                            <TableCell sx={{ width: '100%' }}>
                                <Stack alignItems='left' direction='row' spacing={1}>
                                {pc.name.length > 30 ? (
                                    <p title={pc.name}>{pc.name.slice(0, 30)}...</p>
                                ) : (
                                    <Typography variant='body2'>{pc.name}</Typography>
                                )}
                                </Stack>
                            </TableCell>
                            <TableCell sx={{
                                minWidth: "100px"
                            }}>
                                {pi.duration / 1000 < 1000 && (
                                    <Typography>{pi.duration / 1000} s</Typography>
                                )}
                            </TableCell>
                            </TableRow>
                        );
                        })}
                </TableBody>
            </Table>
            <Box sx={{
                display : "flex",
                justifyContent: "center",
                mt: 3
            }}>
                <Button onClick={onClose}>Close</Button>
            </Box>
        </DialogContent>
    </Dialog>
  );
};

export default PlaylistContentList;
